import { render, staticRenderFns } from "./MilkVatCorrections.vue?vue&type=template&id=ca5db6c6&"
import script from "./MilkVatCorrections.vue?vue&type=script&lang=ts&"
export * from "./MilkVatCorrections.vue?vue&type=script&lang=ts&"
import style0 from "./MilkVatCorrections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports